

            <div class="box-body no-padding">
                <div class="col-xs-12">
                    <h3>Opções para Convênios</h3>
                    <hr>
                    <div class="col-md-12" >
                        <button class="btn btn-app" pTooltip="Listar Convênios" [routerLink]="['listar']" tooltipPosition="top" routerLink="view"
                            routerLinkActive="btn-app-active">
                            <i class="fa fa-list-alt"></i> Listar
                        </button>
                        <button class="btn btn-app" pTooltip="Cadastrar Convênios" [routerLink]="['novo']" tooltipPosition="top" routerLink="view"
                            routerLinkActive="btn-app-active">
                            <i class="fa fa-plus"></i> Novo
                        </button>
                       
                        
                    </div>
                </div>

                <div class="col-md-12">
                    <hr>
                </div> 

                <div class="col-md-12">
                    <router-outlet></router-outlet>
                </div>

                <div class="col-md-12">
                    <hr>
                </div>

            </div>
        


    